<div *ngIf="isSuccess" class="container d-flex flex-column align-items-start pt-30 pb-30 mb-30">
    <div class="icon">🥳</div>
    <h1 class="display-4 mt-10">You have successfully signed up!</h1>
    <div class="display-6 main-color">Thank you!</div>
</div>
<div *ngIf="!isSuccess" class="container d-flex flex-column align-items-start pt-30 pb-30 mb-30">
    <div class="icon">🙁</div>
    <div class="display-4 mt-10">Unfortunately, your payment did not go through.</div>
    <div class="col-lg-3 col-md-6 col-sm-12 mt-25">
        <button routerLink="/checkout" mat-flat-button color="tagus" class="w-100">Try again</button>
    </div>
</div>
  